import PropTypes from 'prop-types';
import swedenFlagSvg from '@client/shared/icons/flag-sweden.svg';
import denmarkFlagSvg from '@client/shared/icons/flag-denmark.svg';
import norwayFlagSvg from '@client/shared/icons/flag-norway.svg';
import finlandFlagSvg from '@client/shared/icons/flag-finland.svg';

const CountryFlag = (countryCode) => {
  switch (countryCode) {
    case 'SE':
      return swedenFlagSvg;
    case 'NO':
      return norwayFlagSvg;
    case 'DK':
      return denmarkFlagSvg;
    case 'FI':
      return finlandFlagSvg;
    default:
      return norwayFlagSvg;
  }
};

CountryFlag.propTypes = {
  countryCode: PropTypes.string.isRequired,
};

export default CountryFlag;
